import {
  useEditConcreteMixDesignMutation,
  useConcreteMixDesignsQuery,
} from 'schema'
import { createStrictContext } from 'utils/createContext'
import {
  DefaultMutationHookOptions,
  DefaultQueryHookOptions,
} from 'utils/defaults'
import { useCIMSModalValues } from 'components/CIMSModal/hooks/useCIMSModal'
import { ConcreteMixDesignsContext, ConcreteMixDesign } from './types'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } =
  createStrictContext<ConcreteMixDesignsContext>('ConcreteMixDesignsContext')

export const useConcreteMixDesignsContext = useContextFn

export const ConcreteMixDesignsProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()

  const query = useConcreteMixDesignsQuery({
    ...DefaultQueryHookOptions,
    variables: {
      projectId,
    },
  })

  const create = useCIMSModalValues<ConcreteMixDesign>()

  const [edit] = useEditConcreteMixDesignMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({ editConcreteMixDesign: { mixDesign } }) =>
      simpleEditNotification(mixDesign.mixDesignNumber ?? mixDesign.globalId),
  })

  return (
    <Provider
      key="cmd-data-provider"
      value={{
        ...query,
        concreteMixDesigns: query.data?.concreteMixDesigns?.records ?? [],
        create,
        edit,
      }}
    >
      {children}
    </Provider>
  )
}
